export const galleryImages = [
  {
    id: 1,
    image: 'https://storage.helloreaddy.io/project_files/1fff4f2a-b372-4b40-8698-6f714b3b8587/9ee3f36a-85e3-49fd-92d0-9d70761223a6_compressed_Captura-de-tela-2026-07-30-171639.webp',
    alt: 'Interior da barbearia com cadeiras vintage e iluminação quente',
  },
  {
    id: 2,
    image: 'https://storage.helloreaddy.io/project_files/1fff4f2a-b372-4b40-8698-6f714b3b8587/d6fdc902-b2f5-4e15-bab5-cdd0744b89c4_compressed_Captura-de-tela-2026-07-30-184812.webp',
    alt: 'Barbeiro utilizando navalha com precisão',
  },
  {
    id: 3,
    image: 'https://storage.helloreaddy.io/project_files/1fff4f2a-b372-4b40-8698-6f714b3b8587/2dac046c-8077-4acb-94ea-566602476b58_compressed_Captura-de-tela-2026-07-30-171728.webp',
    alt: 'Produtos premium e ambiente da barbearia',
  },
  {
    id: 4,
    image: 'https://storage.helloreaddy.io/project_files/1fff4f2a-b372-4b40-8698-6f714b3b8587/dd677dd0-c1e7-4b8a-abb0-e7ede521aca0_compressed_Captura-de-tela-2026-07-30-192112.webp',
    alt: 'Cliente recebendo toalha quente',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Barbershop%20client%20after%20haircut%20looking%20at%20mirror%2C%20satisfied%20expression%2C%20perfect%20grooming%2C%20dark%20masculine%20interior%2C%20warm%20lighting%2C%20cinematic%20portrait%2C%20stylish%20man%2C%20confidence%2C%20charcoal%20and%20gold%20tones&width=800&height=1000&seq=gallery-05&orientation=portrait',
    alt: 'Cliente satisfeito após o corte',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Wide%20angle%20view%20of%20luxury%20barbershop%20with%20multiple%20barbers%20working%2C%20dark%20sophisticated%20interior%2C%20warm%20atmospheric%20lighting%2C%20leather%20chairs%2C%20wood%20floors%2C%20masculine%20club%20aesthetic%2C%20cinematic%20photography&width=800&height=600&seq=gallery-06&orientation=landscape',
    alt: 'Visão geral da barbearia em funcionamento',
  },
];